var TermsController = (function () {
    function TermsController($state, $scope, socket, config, env, $localStorage, jwtHelper, $login, notify) {
        var _this = this;
        this.$state = $state;
        this.$scope = $scope;
        this.socket = socket;
        this.config = config;
        this.env = env;
        this.$localStorage = $localStorage;
        this.jwtHelper = jwtHelper;
        this.$login = $login;
        this.notify = notify;
        this.events = { confirming: false, serverError: undefined, loaded: false };
        this.socket.forward('config.terms_confirmed', this.$scope);
        this.$scope.$on('socket:config.terms_confirmed', function (event, data) {
            _this.events.confirming = false;
            if (data.error) {
                _this.events.serverError = data.error;
            }
            else {
                // Successfully updated the User Profile at the server
                _this.env.user.termsOk = true; // Update env service
                // Update browser
                document.cookie = 'io-user' + '=' + data.cookie; // Update cookie is browser's cookies
                _this.$localStorage.user = data.cookie; // as well as browser's local storage
                _this.$state.go('queue', {
                    id: _this.env.getDefaultQueue()
                });
            }
        });
        this.socket.forward('config.latest_terms', this.$scope);
        this.$scope.$on('socket:config.latest_terms', function (event, data) {
            _this.events.loaded = true;
            if (data.error) {
                _this.events.serverError = data.error;
            }
            else {
                _this.currentTerms = data.terms;
            }
        });
    }
    TermsController.prototype.$onInit = function () {
        this.config.getLatestTermsOfUse();
    };
    TermsController.prototype.confirm = function () {
        this.events.confirming = true;
        this.config.updateUserTermsConfirm(this.currentTerms.version);
    };
    TermsController.$inject = ['$state', '$scope', 'socket', 'config', 'env', '$localStorage', 'jwtHelper', '$login', 'notify'];
    return TermsController;
}());
var TermsComponent = (function () {
    function TermsComponent() {
        this.templateUrl = 'terms.html';
        this.controllerAs = 'vm';
        this.controller = TermsController;
    }
    return TermsComponent;
}());
angular
    .module('application')
    .component('termsSection', new TermsComponent());

//# sourceMappingURL=terms.component.js.map
